import { appConfig, pad } from "../../../utils";

export const addRiskRegisterForm = ({ form, store, router, db }) => {
    const nextRevision = 1;
    const nextRevisionID = `--${pad(nextRevision, 2)}`;

    form.setConfig({
        "title": "Add Risk Register Form",
        "type": "push",
        "location": "SafetyManagement/RiskRegister",
        "fields": [{
            "label": "Number",
            "type": "value",
            value() {
                return `${appConfig.docPrefix}RR-${pad(store.state.counts.riskreg.count)}`
            }
        }, {
            "label": "Title",
            "name": "Title",
            "type": "text",
        }, {
            "label": "File",
            "name": "File",
            "type": "file",
            "required": true
        }],
        async preSubmitHook({ db }) {
            const number = await db.utils.allocateCount("counts/riskreg/count");
            return {
                "Number": `${appConfig.docPrefix}RR-${pad(number)}`,
            }
        },
        async postSubmitHook({ files, typeRef }) {
            for (const file of files) {
                await db.upload(`Database/RiskReg/${typeRef.key}/Revisions/${nextRevisionID}`, file[0]);
            }

            await db.update(`SafetyManagement/RiskRegister/${typeRef.key}/`, {
                "Revision": nextRevision,
                "RevisionID": nextRevisionID,
                [`Revisions/${nextRevisionID}`]: {
                    "Revision": nextRevision,
                    "By": store.state.user.Basic.name,
                    "Date": new Date().toISOString(),
                    "ID": nextRevisionID,
                    "File": files[0][0].name,
                }
            });

            return;
        }
    });
    form.toggle();
};

export const reviseRiskRegister = ({ form, pageItem, store, db }) => {
    const nextRevision = parseInt(pageItem.Revision) + 1;
    const nextRevisionID = `--${pad(nextRevision, 2)}`;

    form.setValues(pageItem);
    form.setConfig({
        "title": "Revise Risk Register Form",
        "type": "update",
        "location": `SafetyManagement/RiskRegister/${pageItem.ID}`,
        "fields": [{
            "label": "Next Revision",
            "type": "value",
            value() {
                return nextRevision;
            }
        }, {
            "label": "File",
            "name": "File",
            "type": "file",
            "required": true
        }],
        async postSubmitHook({ files }) {
            for (const file of files) {
                await db.upload(`Database/RiskReg/${pageItem.ID}/Revisions/${nextRevisionID}`, file[0]);
            }

            await db.update(`SafetyManagement/RiskRegister/${pageItem.ID}/`, {
                "Revision": nextRevision,
                "RevisionID": nextRevisionID,
                [`Revisions/${nextRevisionID}`]: {
                    "Revision": nextRevision,
                    "Date": new Date().toISOString(),
                    "By": store.state.user.Basic.name,
                    "ID": nextRevisionID,
                    "File": files[0][0].name,
                }
            });

            return;
        }
    });
    form.toggle();
};
